<template>
<div>
  <el-dialog
    top="5vh"
    v-loading="loading"
    title="票据查询"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    <div style="height: 78vh;overflow-y: auto;">
      <el-button @click="getData">查询</el-button>
      <el-button @click="updatePayment">结算方式调整</el-button>
<!--      <el-button >结算方式调整（全部）</el-button>-->
      <el-button @click="dialogVisible=false">关闭</el-button>
      <div>
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
          <el-descriptions-item label="发票代码">
            <el-input size="mini" v-model="where.invoice_code" clearable placeholder="发票代码"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="房产信息">
            <el-select v-model="where.house_name" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
              <el-option v-for="item in house_list" :key="item.id" :label="item.house" :value="item.house"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="业务标志">
<!--            <el-select v-model="where.bill_type" size="mini" placeholder="业务标志" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">-->
<!--              <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>-->
<!--            </el-select>-->
          </el-descriptions-item>
          <el-descriptions-item  label="收费期间">
            <el-date-picker v-model="where.start_charge_time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
            <span style="margin-left: 1px;margin-right: 1px;">至</span>
            <el-date-picker v-model="where.end_charge_time" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="收费项目">
            <el-select v-model="where.chang_item_id" size="mini" placeholder="收费项目" filterable remote clearable
                       reserve-keyword :remote-method="getHouseChargeItemList" style="width: 100%;">
              <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.chargeItem_name"
                         :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item  label="计费周期">
            <el-date-picker v-model="where.start_charging_time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
            <span style="margin-left: 1px;margin-right: 1px;">至</span>
            <el-date-picker v-model="where.end_charging_time" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="每页显示">
<!--            <el-select v-model="where.chang_item_id" size="mini" placeholder="收费项目" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">-->
<!--              <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>-->
<!--            </el-select>-->
          </el-descriptions-item>
          <el-descriptions-item  label="">

          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top: 10px;">
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="pageData.list"
          border
          tooltip-effect="dark"
          style="width: 100%"
          height="55vh"
          @selection-change="handleSelectionChange"
          :summary-method="getSummaries"
          show-summary>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="customer_name" label="客户" width="120"></el-table-column>
          <el-table-column prop="house_name" label="房产" width="320"></el-table-column>
          <el-table-column prop="chang_items_name" label="收费项目" width="150"></el-table-column>
          <el-table-column prop="charg_standard_name" label="收费标准" width="150"></el-table-column>
          <el-table-column prop="business_category_name" label="业务类别" width="150"></el-table-column>
          <el-table-column prop="settlement_method_name" label="结算方式" width="150"></el-table-column>
          <el-table-column prop="billing_cycle" label="计费周期" width="150">
            <template slot-scope="scope">
              {{scope.row.billing_cycle_start}} ~ {{scope.row.billing_cycle_end}}
            </template>
          </el-table-column>
          <el-table-column prop="money" label="缴款金额" width="150"></el-table-column>
<!--          <el-table-column prop="discount_amount" label="折扣金额" width="150"></el-table-column>-->
<!--          <el-table-column prop="tax_amount" label="税额" width="150"></el-table-column>-->
<!--          <el-table-column prop="not_tax_amount" label="不含税金额" width="150"></el-table-column>-->
<!--          <el-table-column prop="tax_rate" label="税率" width="150"></el-table-column>-->
          <el-table-column prop="invoicing_time" label="发生时间" width="150"></el-table-column>
<!--          <el-table-column prop="payment_time" label="交账时间" width="150"></el-table-column>-->
<!--          <el-table-column prop="write_off_time" label="核销时间" width="150"></el-table-column>-->
<!--          <el-table-column prop="accounting_period" label="账期" width="150"></el-table-column>-->
          <el-table-column prop="invoicing_user_name" label="操作员" width="150"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-link type="primary" @click="chargeAgainst(scope.row)">冲销</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pages">
      <!--        <Page :total="pageData.count" :page-size="pageData.page" @on-change="onPage" show-total />-->
      <el-pagination background layout="prev, pager, next" :total="pageData.count*1" :page-size="pageData.page_size*1"
                     :current-page="pageData.page*1" @current-change="onPage"></el-pagination>
    </div>
  </el-dialog>
  <SelectPayment ref="SelectPayment" />
</div>
</template>

<script>
import SelectPayment from "./SelectPayment";
export default {
  name: "FinanceBillDetailed",
  components: {SelectPayment},
  data(){
    return{
      loading:false,
      dialogVisible:false,
      where:{
        invoice_code:"",
        house_name:"",
        start_charge_time:"",
        end_charge_time:"",
        chang_item_id:"",
        start_charging_time:"",
        end_charging_time:"",
        business_ids:"",
        source_id:""
      },
      pageData:{
        page:0,
        page_size:20,
        list:[],
        count:0
      },
      house_list:[],
      house_charge_item_list:[],
      house_charge_list:[],
      order_list:[]
    }
  },
  methods:{
    show(obj){
      const that=this;
      that.project_id=obj.project_id
      that.where.house_name=obj.house_name
      that.where.chang_item_id=obj.chang_item_id
      that.where.business_ids=obj.business_ids
      that.where.source_id=obj.source_id
      that.dialogVisible=true;
      that.getHouseChargeItemList()
      that.getData();
    },
    getData(){
      const that=this;
      that.loading=true;
      let where=ERP.reJson(that.where);
      where.page=that.pageData.page;
      where.page_size=that.pageData.page_size;
      ERP.getRequest({
        url:"admin/FinanceBillDetailed/getBillBillDetailedList",
        data:where
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }else {
          that.$message.error(ret.msg||'查询异常')
        }
      })
    },
    handleClose(done) {
      done();
    },
    handleSelectionChange(val) {
      const that=this;
      that.order_list = val;

    },
    chargeAgainst(item){

    },
    onPage(page) {
      const that = this;
      that.pageData.page = page;
      that.getData()
    },
    //远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name=' + query, {
          'Content-Type': 'application/json'
        }).then(backdata => { // 异步执行成功后
          this.house_list = backdata.data.data;
        });
      }
    },
    getHouseChargeItemList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/HouseChargeitemName/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.house_charge_item_list = ret.data.list;
        }
      })
    },
    getSummaries(param){
      const { columns, data } = param;
      console.log(columns)
      const sums = [];
      columns.forEach((column, index) => {
        if(column.label==='计费周期'){
          sums[index] = '总价';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    updatePayment(){
      const that=this;
      if(that.order_list.length===0){
        that.$message.error('请勾选票据号');
        return false;
      }

      that.$refs.SelectPayment.show(payment_id=>{
        let ids=that.order_list.map(ret=>ret.id)
        ERP.postRequest({
          url:"admin/FinanceBillDetailed/updatePayment",
          data:{
            ids:ids.join(','),
            source_id:that.where.source_id,
            payment_id:payment_id,
            bill_number:that.where.bill_number
          }
        },ret=>{
          if(ret.code){
            that.$message.success('操作成功');
            that.getData()
          }else {
            that.$message.error(ret.msg||'操作异常');
          }
        })
      })

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/FinanceBillDetailed.vue